export default {
  image: {
    type: 'photo must be JPG/PNG',
    sizeLt2M: 'photo must be smaller than 2MB'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/public/file.js